export interface StatusColor {
  bg: string;
  text: string;
  border: string;
}

export const STATUS_COLORS: Record<string, StatusColor> = {
  active: { bg: 'bg-emerald-100', text: 'text-emerald-800', border: 'border-emerald-200' },
  pending: { bg: 'bg-orange-100', text: 'text-orange-800', border: 'border-orange-200' },
  completed: { bg: 'bg-sky-100', text: 'text-sky-800', border: 'border-sky-200' },
  cancelled: { bg: 'bg-rose-100', text: 'text-rose-800', border: 'border-rose-200' },
  'in-progress': { bg: 'bg-violet-100', text: 'text-violet-800', border: 'border-violet-200' },
  scheduled: { bg: 'bg-sky-100', text: 'text-sky-800', border: 'border-sky-200' },
  urgent: { bg: 'bg-rose-100', text: 'text-rose-800', border: 'border-rose-200' },
  normal: { bg: 'bg-gray-100', text: 'text-gray-800', border: 'border-gray-200' },
  default: { bg: 'bg-gray-100', text: 'text-gray-800', border: 'border-gray-200' },
};

export interface Record {
  id: string;
  title: string;
  subtitle?: string;
  status?: string;
  date?: string;
  value?: string;
  metadata?: Record<string, any>;
}

export interface RecordSection {
  title: string;
  records: Record[];
  maxItems?: number;
  showViewAll?: boolean;
}
